import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function ProtectedRoutes({ children }) {
  
  const { userId,roles }= useSelector((state) => state.authReducer)
  const isLoggedIn = !!userId;
  const pending = roles?.length === 0 ? true: false;
  

  if (window.location.href.match(/access_token=([^&]+)/)) {
      const match = window.location.href.match(/access_token=([^&]+)/)
      const accessToken = match ? match[1] : null;
      if (accessToken){
        localStorage.setItem("token", accessToken);
      }
      <Navigate to="/login" replace />;
    }

  if (!isLoggedIn) return <Navigate to="/login" replace />;

  if (pending && !localStorage.getItem("auth-token")) {
    return <Navigate to="/login" replace />;
  }
  return children;
}